<template>
  <div
    class="container pa-0"
    id="objects-list"
  >
    <div class="row">
      <div class="col">
        <div class="images-viewer shadow__">
          <!---->
          <div
            class="container pa-0"
            rooms=""
          >
            <div class="row no-gutters">
              <div class="col col-12">
                <div
                  class="viewer-image viewer-image-homepage"
                  style="height: 462.938px"
                >
                  <div class="viewer-image-middle-container">
                    <div class="v-img-container">
                      <div class="v-image v-responsive theme--light">
                        <div
                          class="v-responsive__sizer"
                          style="padding-bottom: 66.6667%"
                        ></div>
                        <div
                          class="v-image__image v-image__image--cover"
                          style="
                            background-image: url('https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/large/1617028212682_47.jpg');
                            background-position: center center;
                          "
                        ></div>
                        <div
                          class="v-responsive__content"
                          style="width: 2100px"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!---->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HotImagePlaceholder',
}
</script>
